import { LogFragment } from '@gql'
import React from 'react'
import NewsLog from './NewsLog'
import { NewsSeparator } from './NewsSeparator'

interface Props {
  logs: LogFragment[]
  // A separator above the first card too, to hang the list from a header
  // card (the dashboard); in a circle's panel there is none (#109)
  showSeparatorTop?: boolean
}

// The governance tab's feed, laid out like NewsList: cards joined by the
// same vertical separator.
export default function NewsLogList({ logs, showSeparatorTop }: Props) {
  return (
    <>
      {logs.map((log, index) => (
        <React.Fragment key={log.id}>
          {(showSeparatorTop || index !== 0) && <NewsSeparator />}
          <NewsLog log={log} />
        </React.Fragment>
      ))}
    </>
  )
}
